import { Alert, Col, Row, Spin, Typography } from 'antd';
import SsoUsers from 'libs/api/ssoUsers';
import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useNavigate } from 'hooks/useNavigate';

const api = new SsoUsers();

const UserConfirmation = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [completed, setCompleted] = useState(false);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const currentParams = Object.fromEntries([...searchParams]);
        await api.confirm({
          params: {
            email_token: currentParams.email_token,
          },
        });
        setCompleted(true);
        navigate('/');
      } catch (e) {
        setErrors(e?.response?.data);
      } finally {
        setLoading(false);
      }
    })();
  }, [searchParams, navigate]);

  return (
    <>
      <Row justify='center' style={{ paddingTop: '30vh' }} gutter={[0, 20]}>
        <Col span={24}>
          <Row justify='center'>
            <Col>
              <Spin spinning={loading} size='large' />
            </Col>
          </Row>
        </Col>
        {!loading && !!errors && (
          <>
            <Col span={24}>
              <Row justify='center'>
                <Col>
                  {Object.keys(errors).map((key) => (
                    <Alert message={errors[key]} type='error' />
                  ))}
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row justify='center'>
                <Col>
                  <Typography.Link>
                    <Link to='/login'>Login</Link>
                  </Typography.Link>
                </Col>
              </Row>
            </Col>
          </>
        )}
      </Row>
    </>
  );
};

export default UserConfirmation;
